import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  signUpForm: FormGroup;
  errorMessage: string; 
  captcha:boolean

  constructor(private formBuilder: FormBuilder, 
              private authService: AuthService,
              private router : Router) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(){
    this.signUpForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.pattern(/[0-9a-zA-Z]{6,}/)]],
      name: ['', [Validators.required]], 
      service : ['autre', [Validators.required]],
      profil: ['utilisateur', [Validators.required]]
    });
  }

  resolved(captchaResponse: string) {
    this.captcha = true
}
  onSubmit(){
    const email = this.signUpForm.get('email').value;
    const password = this.signUpForm.get('password').value;
    const name = this.signUpForm.get('name').value;
    const service = this.signUpForm.get('service').value;
    const profil = this.signUpForm.get('profil').value;
    if (this.captcha == true) {
      this.authService.createNewUser(email,password,name, service, profil).then(
        ()=>{
          this.router.navigate(['/home']);
        },
        (error)=>{
          this.errorMessage = error;
        }
      );
    }
    else{
      this.errorMessage = "Captcha incomplet."
    }
    

  }

}
